import React from 'react';
import { Users, Award, Clock, MapPin } from 'lucide-react';
import SEO from '../components/SEO';

export default function AboutPage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <SEO 
        title="Hakkımızda"
        description="VIATERRA Travel Agency - İstanbul Turda. Profesyonel rehberlerimizle İstanbul'un zengin tarihini ve kültürünü keşfedin. TÜRSAB: 18741"
      />
      
      {/* Header */}
      <section className="bg-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="about-page-title">
            Hakkımızda
          </h1>
          <p className="text-lg text-gray-300">
            İstanbul'u size en iyi şekilde tanıtmak için buradayız
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Biz Kimiz?</h2>
              <p className="text-lg text-gray-600 mb-6">
                İstanbul Turda (VIATERRA TRAVEL AGENCY) olarak, şehrin zengin tarihini, eşsiz kültürünü ve gizli köşelerini ziyaretçilerimizle paylaşmak için tutkuyla çalışıyoruz. Her yürüyüş turumuz, profesyonel rehberlerimiz eşliğinde unutulmaz bir deneyim sunmak üzere tasarlanmıştır.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Amacımız, İstanbul'u sadece görmekle kalmayıp, yaşamaktır. Her adımda tarihin izini sürerken, yerel hikayeler, lezzetler ve insanıyla tanışın.
              </p>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-r-lg">
                <p className="font-bold text-gray-900 mb-2">VIATERRA TRAVEL AGENCY</p>
                <p className="text-sm text-gray-700">TÜRSAB Belge No: 18741</p>
                <p className="text-sm text-gray-600 mt-2">
                  Esenkent Mahallesi Onur Güvener Cd Necati Cumali Sk.<br />
                  Truva Evleri No: 8, Esenyurt / İstanbul
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_tour-booking-33/artifacts/j0wej94q_IMG_20260127_171857_332.jpg"
                alt="Tur grubu"
                className="rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Değerlerimiz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              İşimizin merkezinde olan değerler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Users className="text-orange-500" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Misafir Memnuniyeti</h3>
              <p className="text-gray-600">Her misafirimiz bizim için değerlidir ve en iyi deneyimi sunmak için çalışırız.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Award className="text-orange-500" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Kalite</h3>
              <p className="text-gray-600">Profesyonel rehberlerimiz ve titizlikle hazırlanmış rotalarımızla kaliteyi garanti ederiz.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Clock className="text-orange-500" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Zamanlılık</h3>
              <p className="text-gray-600">Turlarımız belirlenen saatlerde başlar ve planlandığı gibi ilerler.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <MapPin className="text-orange-500" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Yerel Bilgi</h3>
              <p className="text-gray-600">İstanbul'u çok iyi tanıyan rehberlerimiz size şehrin gizli yerlerini gösterir.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-orange-500 text-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Hadi İstanbul'u Birlikte Keşfedin!</h2>
          <p className="text-xl mb-8 text-orange-50">
            Profesyonel rehberlerimizle unutulmaz bir İstanbul deneyimi için bugün rezervasyon yapın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/turlar"
              className="px-8 py-4 bg-white text-orange-500 rounded-full font-ui font-bold hover:bg-gray-100 transition-colors"
              data-testid="view-tours-cta"
            >
              Turları İncele
            </a>
            <a
              href="/iletisim"
              className="px-8 py-4 bg-orange-600 text-white rounded-full font-ui font-bold hover:bg-orange-700 transition-colors border-2 border-white"
              data-testid="contact-cta"
            >
              İletişime Geç
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
